import { IBuildingsHasPhotos, IListingPhotos, ISuitesHasPhotos } from '@llws/lift-entity-interfaces';
import app from '@/main';

export const getNewSuitesHasPhotos = (listingPhoto: IListingPhotos, orderBy: number, suiteTypeId: number): ISuitesHasPhotos => ({
  orderBy,
  listingPhoto,
  listingPhotoId: listingPhoto!.id!,
  suiteTypeId,
  created: new Date(),
  createdUserId: parseInt(app()?.$rsGlobals.$currentUser.userId || '0', 10),
});
